import React from 'react';
import { useAuth } from './AuthContext';

const NoProjectAccess: React.FC = () => {
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
      }}
    >
      {/* Radial overlay */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)',
        }}
      />

      <div className="w-full max-w-[600px] mx-4 relative">
        <div
          className="relative overflow-hidden rounded-xl text-center p-6 sm:p-8 border border-white/10"
          style={{
            backgroundColor: 'rgba(15, 23, 42, 0.98)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
          }}
        >
          {/* Top accent bar */}
          <div
            className="absolute top-0 left-0 right-0 h-1"
            style={{
              background: 'linear-gradient(90deg, #2563eb 0%, #4f46e5 100%)',
            }}
          />

          <div className="flex flex-col items-center gap-6">
            {/* Company Logo */}
            <div className="flex items-center justify-center w-full mb-1">
              <img
                src="/encardio.png"
                alt="Encardio Rite Logo"
                className="h-auto max-h-12 w-auto max-w-full object-contain block"
                onError={(e) => {
                  console.error('Logo failed to load:', e);
                }}
              />
            </div>

            {/* Lock icon */}
            <div
              className="w-20 h-20 rounded-full flex items-center justify-center border-2 shadow-lg"
              style={{
                backgroundColor: 'rgba(211, 47, 47, 0.2)',
                borderColor: 'rgba(211, 47, 47, 0.5)',
                boxShadow: '0 8px 16px rgba(211, 47, 47, 0.4)',
              }}
            >
              <svg
                className="w-10 h-10"
                style={{ color: '#ef5350' }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            </div>

            {/* Title */}
            <h2
              className="text-xl font-bold mb-2"
              style={{
                background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              No Access to CalibraOne
            </h2>

            {/* Description */}
            <p className="text-[15px] leading-relaxed text-white/80 max-w-[90%] mb-2">
              You are logged in successfully, but your account does not have permission to access the CalibraOne.
            </p>

            {/* Additional info */}
            <p className="text-[15px] leading-relaxed text-white/80 max-w-[90%] mb-1">
              To request access, please contact your system administrator and ask to be assigned to the appropriate role.
            </p>

            {/* User info */}
            {user?.email && (
              <div
                className="mt-2 p-4 w-full rounded-lg border text-center"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  borderColor: 'rgba(255, 255, 255, 0.1)',
                }}
              >
                <p className="text-xs text-white/60 block mb-1">Logged in as:</p>
                <p className="text-sm font-medium text-white">{user.email}</p>
              </div>
            )}

            {/* Logout button */}
            <button
              type="button"
              onClick={handleLogout}
              className="mt-6 px-6 py-3 rounded-lg text-base font-semibold text-white flex items-center justify-center gap-2 transition-all duration-300 hover:-translate-y-0.5"
              style={{
                background: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
                boxShadow: '0 4px 15px rgba(37, 99, 235, 0.4)',
              }}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              Logout
            </button>

            {/* Help text */}
            <p className="text-xs text-white/60 mt-2 block">
              Need help? Contact your system administrator
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoProjectAccess;
